import HTTPClient from './http-client';

const options = {
  cache: {
    maxAge: 5 * 60 * 1000,
    exclude: { query: false }
  }
}

const END_POINT = '/forecasts';

const loadForecastsWeather = async ({type, source, id}) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}?type=${type}&source=${source}&location_id=${id}`,
    options
  );
}

export {
  loadForecastsWeather
}
